import React, { useState, useEffect } from 'react';
import { doc, setDoc, getDocs } from "firebase/firestore"; 
import { db, storage } from "../firebase/firebaseConfig";
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
} from "firebase/storage";
import { useNavigate } from 'react-router-dom';
import NewPlaceholderImage from "../resources/new-placeholder.jpg";
import { useParams } from 'react-router-dom';
import { collection } from 'firebase/firestore';

const EditGroup = (e) => {
  const navigate = useNavigate();
  const { groupId } = useParams();
  
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [publicGroup, setPublicGroup] = useState("");
  const [groupManagers, setGroupManagers] = useState("");
  const [visibility, setVisibility] = useState("");
  const [featuredImage, setFeaturedImage] = useState(null); 
  const [placeholderImage, setPlacholderImage] = useState(NewPlaceholderImage);
  const [featuredImageChange, setFeaturedImageChange] = useState(false);

  const [member, setMember] = useState([]);
  
  useEffect(() => {
      const fetchGroupData = async() => {
          const querySnapshot = await getDocs(collection(db, "Groups"));
          const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          
          for (let key in documents) {
            if (documents.hasOwnProperty(key)) {
              if (documents[key].id === groupId) {
                    setTitle(documents[key].Title);
                    setDescription(documents[key].Description);
                    setPublicGroup(documents[key].PublicGroup);
                    setGroupManagers(documents[key].GroupManagers);
                    setVisibility(documents[key].Visibility);
                    setFeaturedImage(documents[key].FeaturedImage);
                    setPlacholderImage(documents[key].FeaturedImage);
              }
            }
          }
        }

      fetchGroupData();
  }, []);

  useEffect(() => {
        const fetchMemberData = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "Members"));
                const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
                const matchingMembers = documents.filter(doc => doc.Groups && doc.Groups.some(group => group === title));
                
                // Update the state once after accumulating all matching members
                setMember(matchingMembers);
            } catch (error) {
              console.error("Error fetching data: ", error);
            }
          };

      fetchMemberData();
  }, [title]);

  const generateId = () => {
    return [...Array(20)].map(() => Math.random().toString(36)[2]).join('');
  };

  const uploadImage = () => {
    return new Promise((resolve, reject) => {
      const imageRef = storageRef(storage, `${generateId()}`);

      uploadBytes(imageRef, featuredImage)
        .then((snapshot) => {
          console.log("Image uploaded successfully");

          getDownloadURL(snapshot.ref)
            .then((url) => {
              console.log("Download URL: ", url);
              resolve(url); 
            })
            .catch((error) => {
              console.error("Error getting download URL: ", error);
              reject(error); 
            });
        })
        .catch((error) => {
          console.error("Error uploading image: ", error);
          reject(error); 
        });
    });
  };

  const createMyGroup = async (e) => {
    e.currentTarget.innerHTML = "Creating Group...";
    e.target.style.cursor = "wait";

    try {
        if(featuredImageChange)  {
            const imageUrl = await uploadImage();

            await setDoc(doc(db, `Groups/${groupId}`), {
                Title: title,
                Description: description,
                PublicGroup: publicGroup,
                GroupManagers: groupManagers,
                Visibility: visibility,
                FeaturedImage: imageUrl,
                Members: 0,
            });

            console.log("Group successfully created!");
        } else {
            await setDoc(doc(db, `Groups/${groupId}`), {
                Title: title,
                Description: description,
                PublicGroup: publicGroup,
                GroupManagers: groupManagers,
                Visibility: visibility,
                FeaturedImage: featuredImage,
                Members: 0,
            });

            console.log("Group successfully created!");
        }

    } catch (error) {
      console.error("Error creating group: ", error);
    }

    navigate('/groups');
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setPlacholderImage(URL.createObjectURL(file));
    setFeaturedImage(file);
    setFeaturedImageChange(true);
  };


  return (
    <div id='content'>
      <h1>Edit Group: {groupId}</h1>
        <div className='row'>
            <div className='col-sm-8'>
                    <h4>Basic Info</h4>
                    <label>Group Title
                    <br/> <input type="text" value={title} onChange={(e) => setTitle(e.target.value)}/></label>
                    <label>Group Description
                    <br/> <textarea value={description} onChange={(e) => setDescription(e.target.value)}/></label>
                    <label className='checkbox-label'><input type="checkbox" checked={publicGroup === "on"} 
                    onChange={(e) => setPublicGroup(e.target.value)}/> Public Group</label>
                    <label>Group Managers
                    <br/> <input type="text" value={groupManagers} onChange={(e) => setGroupManagers(e.target.value)}/></label>
                    <select value={visibility} onChange={(e) => setVisibility(e.target.value)}>
                        <option value="Open - Anyone can Join">Open - Anyone can Join</option>
                        <option value="Closed - Invites Only">Closed - Invites Only</option>
                    </select>

                    <br/>
                    <br/>
                    <br/>
                    
                <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-start'}}>
                    <button onClick={(e) => createMyGroup(e)}>Update Group</button>
                </div>
                <br/>
                <div className='row'>
                    <h4>Group Members:</h4>
                    {member.length > 0 ? (
                        member.map(item => (
                            <div style={{margin: "15px", width:"100px", height:"100px", borderRadius:"5000px", backgroundImage: `url(${item.ProfileImage})`, backgroundSize: "cover" }}></div>
                        ))
                    ) : (
                        <p>No members found</p>
                    )}
                </div>
            </div>
            <div className='col-sm-4' style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', paddingRight: '50px'}}>
                <img src={placeholderImage} width="75%"/>
                <label style={{ cursor: 'pointer', textAlign: 'right'}}  htmlFor="file-upload" className="custom-file-upload">
                    <b>Change Featured Image</b>
                </label>
                <input
                    id="file-upload"
                    type="file"
                    onChange={handleImageChange}
                    style={{ display: 'none' }} 
                />
            </div>
        </div>
    </div>
  );
}

export default EditGroup;
